var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" }, style: { height: _vm.height } },
    [
      _vm.showResetPasswordModal
        ? _c(
            "b-modal",
            {
              attrs: {
                active: _vm.showResetPasswordModal,
                "can-cancel": ["escape", "x"],
                width: _vm.isMobile ? "100%" : "400px",
                scroll: "keep",
              },
              on: {
                "update:active": function ($event) {
                  _vm.showResetPasswordModal = $event
                },
              },
            },
            [
              _c("div", { staticClass: "reset-password-modal" }, [
                _c("div", { staticClass: "reset-password-header" }, [
                  _c("h1", [_vm._v("Reset Password")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reset-password-content" }, [
                  _c("p", [
                    _vm._v(
                      "Enter your email address below and if there is an account associated with it, we will send you a link to\n          reset your password."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "input-submit-container",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.sendResetPasswordEmail.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "input-submit" },
                        [
                          _c(
                            "b-field",
                            {
                              attrs: {
                                message: _vm.emailError,
                                type: { "is-danger": _vm.isEmailInvalid },
                                "custom-class": "has-text-white has-text-left",
                                expanded: "",
                                label: "Email",
                              },
                            },
                            [
                              _c("b-input", {
                                attrs: { expanded: "", type: "email" },
                                model: {
                                  value: _vm.email,
                                  callback: function ($$v) {
                                    _vm.email = $$v
                                  },
                                  expression: "email",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                disabled: !_vm.email,
                                "icon-right": _vm.icon,
                                expanded: "",
                                type: "button",
                                variant: "primary",
                              },
                              on: { click: _vm.sendResetPasswordEmail },
                            },
                            [_vm._v("\n              Send Email\n            ")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.state !== "SIGNED_IN"
        ? _c("div", { staticClass: "sign-in-container" }, [
            _c(
              "div",
              { staticClass: "sign-in-box" },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "transition-group",
                  {
                    staticClass: "sign-in-content",
                    attrs: { mode: "out-in", name: "fade" },
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isIe === true,
                            expression: "isIe === true",
                          },
                        ],
                        key: "0",
                        staticClass: "loading-container",
                      },
                      [
                        _c("img", {
                          staticStyle: {
                            "margin-top": "-45px",
                            height: "100px",
                          },
                          attrs: { src: _vm.chromeIconPath },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "loading-message" }, [
                          _vm._v("Please Load This Page In Chrome"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isIe === false && _vm.state === "LOADING",
                            expression: "isIe === false && state === 'LOADING'",
                          },
                        ],
                        key: "2",
                        staticClass: "loading-container",
                      },
                      [
                        _c("fa", {
                          staticClass: "spinner",
                          attrs: { icon: "spinner", size: "3x", spin: "" },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "loading-message" }, [
                          _vm._v("Loading..."),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isIe === false &&
                              _vm.state === "SIGN_IN" &&
                              _vm.loginType === null,
                            expression:
                              "isIe === false && state === 'SIGN_IN' && loginType === null",
                          },
                        ],
                        key: "3",
                        staticClass: "log-in-content",
                      },
                      [
                        _vm.emailOnly === false
                          ? _c("div", {
                              staticClass: "google-sign-in",
                              attrs: { id: "google-sign-in-button" },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.emailOnly === false
                          ? _c("div", { staticClass: "or-separator" }, [
                              _c("div", { staticClass: "line" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "or" }, [_vm._v(" OR")]),
                              _vm._v(" "),
                              _c("div", { staticClass: "line" }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            staticClass: "input-submit-container",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.sendConfirmation.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "input-submit",
                                class: { "email-only": _vm.emailOnly },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.email,
                                      expression: "email",
                                    },
                                  ],
                                  attrs: {
                                    placeholder: "Enter your email address",
                                    type: "email",
                                  },
                                  domProps: { value: _vm.email },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.email = $event.target.value
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "submit-button",
                                    attrs: { disabled: !_vm.email },
                                  },
                                  [_c("b-icon", { attrs: { icon: _vm.icon } })],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "sign-in-help" }, [
                              _c("p", [_vm._v("Need Help Logging In?")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v("Call "),
                                _c(
                                  "a",
                                  { attrs: { href: "tel:+441359256311" } },
                                  [_vm._v("01359 256311")]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isIe === false &&
                              _vm.state === "SIGN_IN" &&
                              _vm.loginType === "google",
                            expression:
                              "isIe === false && state === 'SIGN_IN' && loginType === 'google'",
                          },
                        ],
                        key: "4",
                        staticClass: "popup-prompt",
                      },
                      [
                        _c("p", [
                          _vm._v("Please sign in using the pop-up window"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isIe === false &&
                              _vm.state === "SIGN_IN_TOKEN_REQUIRED",
                            expression:
                              "isIe === false &&  state === 'SIGN_IN_TOKEN_REQUIRED'",
                          },
                        ],
                        key: "5",
                        staticClass: "enter-token",
                      },
                      [
                        _c("p", { staticClass: "token-message" }, [
                          _vm._v("Enter the code that we emailed you below"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "form",
                          { staticClass: "input-submit-container" },
                          [
                            _c("div", { staticClass: "input-submit" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tokenPartOne,
                                    expression: "tokenPartOne",
                                  },
                                ],
                                ref: "tokenPartOne",
                                staticClass: "token has-text-centered",
                                attrs: { maxlength: "3", placeholder: "XXX" },
                                domProps: { value: _vm.tokenPartOne },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.tokenPartOne = $event.target.value
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "white",
                                    "font-size": "24px",
                                  },
                                },
                                [_vm._v("-")]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.tokenPartTwo,
                                    expression: "tokenPartTwo",
                                  },
                                ],
                                ref: "tokenPartTwo",
                                staticClass: "token has-text-centered",
                                attrs: { maxlength: "3", placeholder: "XXX" },
                                domProps: { value: _vm.tokenPartTwo },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.tokenPartTwo = $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("b-button", {
                              staticClass: "mt-2",
                              attrs: {
                                disabled:
                                  !_vm.tokenPartOne || !_vm.tokenPartTwo,
                                "icon-right": _vm.icon,
                                expanded: "",
                                type: "is-secondary",
                              },
                              on: { click: _vm.confirmLogin },
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "sign-in-help" }, [
                              _c("p", [_vm._v("Need Help Logging In?")]),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: { "text-underline": "#ffc520" },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.loginGuideLink,
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v("Download Guide")]
                                  ),
                                  _vm._v(" or "),
                                  _c(
                                    "a",
                                    { attrs: { href: "tel:+441359256311" } },
                                    [_vm._v("Call 01359 256311")]
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isIe === false && _vm.state === "LOGGED_OUT",
                            expression:
                              "isIe === false && state === 'LOGGED_OUT'",
                          },
                        ],
                        key: "6",
                        staticClass: "error-container",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "error-message",
                            staticStyle: { "margin-bottom": "1em" },
                          },
                          [
                            _vm._v(
                              "You have signed out. Refresh to sign back in."
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "retry-button",
                            staticStyle: { border: "none!important" },
                            on: {
                              click: function ($event) {
                                return _vm.reload()
                              },
                            },
                          },
                          [
                            _c("fa", {
                              staticClass: "spinner",
                              attrs: { icon: "rotate-right", size: "3x" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isIe === false && _vm.state === "ERROR",
                            expression: "isIe === false && state === 'ERROR'",
                          },
                        ],
                        key: "7",
                        staticClass: "error-container",
                      },
                      [
                        _c("fa", {
                          staticClass: "error-icon",
                          attrs: { icon: "exclamation-triangle", size: "4x" },
                        }),
                        _vm._v(" "),
                        _c("p", { staticClass: "error-message" }, [
                          _vm._v(
                            _vm._s(
                              _vm.stateReason
                                ? _vm.stateReason
                                : "Error Logging In"
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "error-message more-info" }, [
                          _vm._v("For Assistance Call "),
                          _c("a", { attrs: { href: "tel:+441359256311" } }, [
                            _vm._v("01359 256311"),
                          ]),
                          _vm._v(" or\n            Email "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "email:flightdeck@projectestimator.co.uk",
                              },
                            },
                            [_vm._v("flightdeck@projectestimator.co.uk")]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "retry-button",
                            on: {
                              click: function ($event) {
                                return _vm.reload()
                              },
                            },
                          },
                          [_vm._v("RETRY")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sign-in-header" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "img/project-estimator-logo.svg" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }